(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/core/assets/javascripts/events/removed-tooltip-event.js') >= 0) return;  svs.modules.push('/components/onboarding/core/assets/javascripts/events/removed-tooltip-event.js');
"use strict";

const VerifyType = svs.components.tbUtils.verify.constants.VerifyType;
const verifyObject = svs.components.tbUtils.verify.verifyObject;
const BaseTooltipEvent = svs.components.onboarding.core.events.BaseTooltipEvent;
const TooltipEventType = svs.components.onboarding.core.events.constants.TooltipEventType;
class RemovedTooltipEvent extends BaseTooltipEvent {
  constructor(props) {
    verifyObject(props).schema({
      tooltip: VerifyType.Element
    });
    super(TooltipEventType.Removed, props);
  }
}

setGlobal('svs.components.onboarding.core.events.RemovedTooltipEvent', RemovedTooltipEvent);

 })(window);